import { useState } from "react";
import { Container, Card } from "react-bootstrap";
import { ChevronDown, ChevronUp, QuestionCircle } from "react-bootstrap-icons";

const faqData = [
  {
    q: "What is Skills Uprise?",
    a: "Skills Uprise is an ed-tech platform providing industry-aligned training, internships, certifications, and assessment exams to make students job-ready",
  },
  {
    q: "How do I take an exam?",
    a: "Login to your account, enter your exam code, and follow the instructions to start the assessment.",
  },
  {
    q: "Is the exam monitored?",
    a: "Yes, the exam is monitored with security measures like tab switching detection and activity tracking.",
  },
  {
    q: "What happens if I lose internet?",
    a: "Your progress is saved. You can rejoin within the allowed time window if connectivity is restored.",
  },
  {
    q: "Are the certifications valid?",
    a: "Yes, certifications are industry-recognized and can be used for career opportunities.",
  },
  {
    q: "How long are the courses?",
    a: "Courses typically range from a few weeks to a few months depending on the specialization.",
  },
  {
    q: "Do you offer placement assistance?",
    a: "Yes, we provide placement support, resume building, and interview preparation.",
  },
  {
    q: "Can I access the exam on mobile?",
    a: "It is recommended to take exams on a desktop/laptop for better monitoring and experience.",
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="faq-page">
      <Container className="py-5">

        {/* HEADER */}
        <div className="text-center mb-5">
          <div className="icon-box mb-3">
            <QuestionCircle size={30} />
          </div>
          <h1 className="fw-bold">Frequently Asked Questions</h1>
          <p className="text-muted">
            Got questions? We've got answers.
          </p>
        </div>

        {/* FAQ LIST */}
        {faqData.map((item, i) => (
          <Card
            key={i}
            className={`faq-card mb-3 ${openIndex === i ? "active" : ""}`}
            onClick={() => setOpenIndex(openIndex === i ? null : i)}
          >
            <Card.Body>

              {/* QUESTION */}
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-3">
                  <div className="faq-number">{i + 1}</div>
                  <h6 className="mb-0 fw-semibold">{item.q}</h6>
                </div>

                {openIndex === i ? (
                  <ChevronUp />
                ) : (
                  <ChevronDown />
                )}
              </div>

              {/* ANSWER */}
              {openIndex === i && (
                <div className="faq-answer mt-3">
                  {item.a}
                </div>
              )}

            </Card.Body>
          </Card>
        ))}

      </Container>

      {/* CSS */}
      <style>{`
        .faq-page {
          min-height: 100vh;
          background: linear-gradient(135deg,#f5f7fb,#eef2ff);
        }

        .icon-box {
          width: 60px;
          height: 60px;
          margin: auto;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 15px;
          background: #eaf2ff;
          color: #0d6efd;
        }

        .faq-card {
          border-radius: 16px;
          border: none;
          cursor: pointer;
          transition: 0.3s;
          background: #f9fbff;
          box-shadow: 0 8px 20px rgba(0,0,0,0.05);
        }

        .faq-card:hover {
          transform: translateY(-2px);
        }

        .faq-card.active {
          background: #eef4ff;
          border: 1px solid #d0e2ff;
        }

        .faq-number {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: #e3edff;
          color: #0d6efd;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
        }

        .faq-answer {
          color: #6c757d;
          line-height: 1.6;
          padding-left: 45px;
        }
      `}</style>

    </div>
  );
};

export default FAQ;